import { ECompanyTypeIdConst } from '@company/companyType/companyType.constants';
import { AppConfigContext } from '@config/AppConfig';
import { useHasPermission } from '@config/config.hooks';
import { IMasterScheduleDetail } from '@masterSchedule/detail/masterScheduleDetail.models';
import { useNominatedInMasterSchedule } from '@masterSchedule/masterSchedule.hooks';
import { ERolePermission, ESiteTransmittalPermission } from '@userProfile/permission/permission.constants';
import { hasPermissionInArray } from '@userProfile/permission/permission.services';
import { useContext } from 'react';

export const useAllowNewLir = () => {
  const appConfigs = useContext(AppConfigContext);
  return hasPermissionInArray(
    appConfigs.configs.myPermissions,
    ESiteTransmittalPermission.PREPARE_REVIEW,
    ECompanyTypeIdConst.REVIEWERS,
  );
};
export const useAllowNewLirWithT1 = (masterScheduleIsCancelled: boolean, masterScheduleType: string) => {
  const isPermitted = useAllowNewLir();
  // TODO check master schedule type
  if (masterScheduleIsCancelled || masterScheduleType === 'D') return false;

  return isPermitted;
};

export const useAllowEndorseReview = (masterSchedule?: IMasterScheduleDetail) => {
  const isPermitted = useHasPermission(
    ERolePermission.REVIEWER_AUTHORISED_REPRESENTATIVE,
    masterSchedule?.responsibleReviewer?.companyTypeId,
    masterSchedule?.responsibleReviewer?.organizationTypeId,
  );
  const { isNominatedReviewer } = useNominatedInMasterSchedule(masterSchedule);
  return isNominatedReviewer && isPermitted;
};
